<template>
    <HelpToolTip :text="t(toolTip)" :helptoken="helptoken">
        <button v-on="{...(disabled?{}:$listeners) }" :class="buttonClass" :style="btnStyle+(maxWidth?(';max-width: '+maxWidth):'')" v-bind="{...$attrs}">
            <v-icon v-if="icon">{{ icon }}</v-icon>
            <div class='v-icon' v-else-if="$slots.icon"><slot name='icon'></slot></div>
            <span v-if="title || $slots.default" class="button-text"><slot>{{ t(title) }}</slot></span>
        </button>
    </HelpToolTip>
</template>

<script>
import HelpToolTip from './HelpToolTip';
    export default {
        props: {
            title: {
                type: String
            },
            icon: {
                type: String,
                default: null
            },
            toolTip: {
                type: String,
                default: null
            },
            helptoken: {
                type: String,
                default: undefined
            },
            btnClass: {
                type: String,
                default: ""
            },
            btnStyle: {
                type: String,
                default: ""
            },
            groupStart: {
                type: Boolean,
                default: false
            },
            groupMid: {
                type: Boolean,
                default: false
            },
            groupEnd: {
                type: Boolean,
                default: false
            },
            primary: {
                type: Boolean,
                default: false
            },
            subprimary: {
                type: Boolean,
                default: false
            },
            circle:  {
                type: Boolean,
                default: false
            },
            light:  {
                type: Boolean,
                default: false
            },
            big:  {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            vertical: {
                type: Boolean,
                default: false
            },
            danger: {
                type: Boolean,
                default: false
            },
            maxWidth:{
                type: String,
                default: undefined
            },
            ghost:{
                type: Boolean,
                default: undefined
            },
            noTr: {
                type: Boolean,
                default: false
            }

        },
        components:{HelpToolTip},
        computed: {
            buttonClass(){
                return "tool-button-container" 
                    + ((this.icon && !this.title) ? " icon-only" : "")
                    + (this.groupStart ? " group-start" : "")
                    + (this.groupMid ? " group-mid" : "")
                    + (this.groupEnd ? " group-end" : "")
                    + (this.primary ? " primary" : "")
                    + (this.subprimary ? " subprimary" : "")
                    + (this.light ? " light" : "")
                    + (this.circle ? " circle" : "")
                    + (this.big ? " big" : "")
                    + (this.disabled ? " disabled" : "")
                    + (this.vertical ? " vertical" : "")
                    + (this.danger ? " danger": "")
                    + (this.maxWidth ? " wrapText": "")
                    + (this.ghost ? " ghost" : "")
                    + (this.btnClass? (' '+this.btnClass) : '');
            }
        },

        data() {
            return {
            }
        },

        watch: {

        },

        mounted() {
        },

        methods: {
            t(s){
                return this.noTr?s: this.$t(s);
            }
        }
    }
</script>

<style scoped>
    button.tool-button-container{
        background-color: var(--brand-light-color);
        color: #444;
        padding: 3px 10px;
        border-radius: 4px;
        display: flex;
        flex-shrink: 0;
        gap: 4px;
        align-items: center;
        justify-content: center;
        font-weight: 400;
        font-size: 15px;
        min-height: 30px;
        min-width: 30px;
    }
    button.tool-button-container .v-icon {
        color: #777;
        fill: #777;
        font-size: 22px;
    }
    button.tool-button-container.icon-only{
        padding: 3px;
    }
    button.tool-button-container:hover{
        background-color: color-mix(in srgb, var(--brand-light-color), white 20%);
    }
    button.tool-button-container.group-start{
        border-bottom-right-radius: 0;
        border-top-right-radius:0
    }
    button.tool-button-container.group-mid{
        border-left: 1px dotted #AAA;
        border-radius: 0;
    }
    button.tool-button-container.group-mid.disabled{
        border-left: 1px dotted #c4c4c4;
    }
    button.tool-button-container.group-end{
        border-bottom-left-radius: 0;
        border-top-left-radius:0;
        border-left: 1px dotted #AAA;
    }
    button.tool-button-container.group-end.disabled{
        border-left: 1px dotted #c4c4c4;
    }
    button.tool-button-container span.button-text{
        white-space: nowrap;
        line-height: normal;
    }

    button.tool-button-container.primary{
        background-color: var(--brand-main-color) !important;
        color: white !important;
    }
    button.tool-button-container.primary .v-icon {
        color: white;
    }

    button.tool-button-container.primary:hover{
        background-color: color-mix(in srgb, var(--brand-main-color), white 10%) !important;
    }

    button.tool-button-container.subprimary{
        background-color: #606060 !important;
        color: white !important;
    }
    button.tool-button-container.subprimary .v-icon {
        color: white;
    }
    button.tool-button-container.subprimary:hover{
        background-color: color-mix(in srgb, #606060, white 10%) !important;
    }

    button.tool-button-container.light{
        background-color: #E0E0E0 !important;
        color: #444 !important;
    }
    button.tool-button-container.light .v-icon {
        color: #777777;
    }
    button.tool-button-container.light:hover{
        background-color: color-mix(in srgb, #E0E0E0, white 30%) !important;
    }

    button.tool-button-container.disabled{
        background-color: #E0E0E0 !important;
        color: #C0C0C0 !important;
        cursor: auto !important;
    }
    button.tool-button-container.disabled .v-icon {
        color: #C0C0C0;
    }
    button.tool-button-container.disabled:hover{
        background-color: #E0E0E0 !important;
    }

    button.tool-button-container.circle{
        border-radius: 999px;
    }

    button.tool-button-container.big{
        min-height: 40px !important;
        min-width: 40px !important;
    }

    button.tool-button-container.vertical{
        flex-direction: column;
        gap: 0;
        padding-top: 6px;
    }

    button.tool-button-container.danger, button.tool-button-container.danger .v-icon{
        color: var(--brand-danger-color) !important;
    }
    button.tool-button-container.danger.disabled, button.tool-button-container.danger.disabled .v-icon{
        color: rgb(194, 151, 151) !important;
    }

    button.tool-button-container.wrapText span.button-text{
        white-space: wrap !important;
    }

    button.tool-button-container.ghost, button.tool-button-container.disabled.ghost{
        background-color: transparent !important;
    }
    button.tool-button-container.ghost:hover{
        background-color: rgba(0,0,0,0.05) !important;
    }
</style>